/* eslint-disable import/named,no-console */
import vue from 'vue';
import {
    SET_ACTIVE_CONVERSATION_ID,
    SET_CONVERSATIONS,
    SET_IS_LOADING_CONVERSATION,
    SET_IS_LOADING_MESSAGES,
    SET_MESSAGES_ON_CONVERSATION,
    SET_IS_LOADING_PROJECT_EVENTS,
    SET_IS_SENDING_MESSAGE,
    SET_SHOULD_DISPLAY_TYPING_EVENT,
} from './_types';

export default {
    [SET_ACTIVE_CONVERSATION_ID](state, conversationId) {
        state.activeConversationId = conversationId;
    },

    [SET_CONVERSATIONS](state, conversations) {
        state.conversations = conversations;
    },

    [SET_IS_LOADING_CONVERSATION](state, isLoading) {
        state.isLoadingConversation = isLoading;
    },

    [SET_IS_LOADING_MESSAGES](state, isLoading) {
        state.isLoadingMessages = isLoading;
    },

    [SET_MESSAGES_ON_CONVERSATION](state, { conversation: activeConversation, messages }) {
        const index = state.conversations
            .findIndex(conversation => conversation.id === activeConversation.id);

        let assign = {
            messages,
        };

        if (activeConversation.messages) {
            assign = {
                messages: [...new Set([
                    ...activeConversation.messages,
                    ...messages,
                ])],
            };
        }

        vue.set(state.conversations, index, Object.assign(
            {},
            activeConversation,
            assign,
        ));
    },

    [SET_IS_LOADING_PROJECT_EVENTS](state, isLoading) {
        state.isLoadingProjectEvents = isLoading;
    },

    [SET_IS_SENDING_MESSAGE](state, isSending) {
        state.isSendingMessage = isSending;
    },

    [SET_SHOULD_DISPLAY_TYPING_EVENT](state, shouldDisplay) {
        state.shouldDisplayTypingEvent = shouldDisplay;
    },
};



// WEBPACK FOOTER //
// ./src/taskflex/conversations/store/_mutators.js